import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  screenshot: {
    id: 'studio.TdzZP4',
    defaultMessage: 'Screenshot of {app}',
  },
  deleteScreenshotTitle: {
    id: 'studio.5Hs6+j',
    defaultMessage: 'Delete screenshot',
  },
  deleteScreenshotBody: {
    id: 'studio.FQM8ei',
    defaultMessage:
      'Are you sure you want to delete this screenshot? This action cannot be undone.',
  },
  deleteCancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  deleteConfirm: {
    id: 'studio.K3r6DQ',
    defaultMessage: 'Delete',
  },
});
